<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bWH790/tc-custom/9780814771174.jpg?1719927329548" alt="This image is the cover for the book Fighting over the Founders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fighting over the Founders
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Explores how politicians, screenwriters, activists, biographers, jurists, museum professionals, and reenactors portray the American Revolution. </b><br/><br/>The American Revolution is all around us. It is pictured as big as billboards and as small as postage stamps, evoked in political campaigns and car advertising campaigns, relived in museums and revised in computer games. As the nation’s founding moment, the American Revolution serves as a source of powerful founding myths, and remains the most accessible and most contested event in US history: more than any other, it stands as a proxy for how Americans perceive the nation’s aspirations. Americans’ increased fascination with the Revolution over the past<br/>two decades represents more than interest in the past. It’s also a site to work out the present, and the future. What<br/>are we using the Revolution to debate?<br/><br/>In<i> Fighting over the Founders</i>, Andrew M. Schocket explores how politicians, screenwriters, activists, biographers, jurists, museum professionals, and reenactors portray the American Revolution. Identifying competing “essentialist” and “organicist” interpretations of the American Revolution, Schocket shows how today’s memories of the American Revolution reveal Americans' conflicted ideas about class, about race, and about gender—as well as the nature of history itself. <i>Fighting over the Founders</i> plumbs our views of the past and the present, and illuminates our ideas of what United States means to its citizens in the new millennium.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew M Schocket
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1309d164